define('shared/initializer/form/adapters/mixins/Empty',[],function () {
    'use strict';
    return function() {}; 
});
